import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { _i, __ } from "../../utils";
import { useStores } from "../../store";
import { useLocation } from "react-router-dom";
import { Popconfirm } from "antd";
const NoticeRevisionNeedsRetrigger = observer(()=>{
    const { optionStore } = useStores();
    const { pathname } = useLocation();
    return optionStore.needsRevisionRetrigger && pathname.indexOf("/edit/") === -1 && pathname.indexOf("/new") === -1 && /*#__PURE__*/ _jsx("div", {
        className: "notice notice-warning inline below-h2 notice-alt",
        style: {
            margin: "10px 0 0 0"
        },
        children: /*#__PURE__*/ _jsxs("p", {
            children: [
                __("You have changed settings that affect the content or behavior of the cookie banner. You should ask all visitors for their consent again."),
                " ",
                "•",
                " ",
                /*#__PURE__*/ _jsx("a", {
                    onClick: ()=>optionStore.updateCurrentRevision({
                            needs_retrigger: true
                        }),
                    children: __("Request new consent")
                }),
                " ",
                "•",
                " ",
                /*#__PURE__*/ _jsx(Popconfirm, {
                    title: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("strong", {
                                children: __("Are you sure you don't want to collect new consents?")
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx("br", {}),
                            _i(__("Consent must be obtained in accordance with {{a}}Art. 7 GDPR{{/a}}. Your visitor must be informed about all circumstances of the consent. However, you have made changes to your cookie banner, which lead to the fact that previously visitors have consented differently or to something different than is now in the cookie banner. Therefore, previously collected consents may have become partially invalid."), {
                                a: /*#__PURE__*/ _jsx("a", {
                                    href: __("https://gdpr-text.com/read/article-7/"),
                                    rel: "noreferrer",
                                    target: "_blank"
                                })
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx("br", {}),
                            __("If you have created a new service like Google Analytics (without visual content blocker), previous visitors can never consent without collecting new consents and you cannot track them, for example.")
                        ]
                    }),
                    placement: "bottomRight",
                    onConfirm: ()=>optionStore.updateCurrentRevision({
                            needs_retrigger: false
                        }),
                    okText: __("Dismiss notice"),
                    cancelText: __("Cancel"),
                    overlayStyle: {
                        maxWidth: 450
                    },
                    children: /*#__PURE__*/ _jsx("a", {
                        children: __("Dismiss notice")
                    })
                })
            ]
        })
    });
});
export { NoticeRevisionNeedsRetrigger };
